import { useMutation } from '@apollo/client';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import { useToast } from '../../toast/Toast.context';
import {
  DELETE_CARPOOL_TRIP,
  DeleteCarpoolTripMutation,
  DeleteCarpoolTripMutationVariables,
} from '../graphql/mutation/deleteCarpoolTripMutation.graphql';
import {
  CARPOOL_TRIPS,
  CarpoolTripsQueryVariables,
} from '../graphql/query/carpoolTripsQuery.graphql';

export const useDeleteCarpoolTripMutation = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const { showToast } = useToast();
  const [mutate] = useMutation<
    DeleteCarpoolTripMutation,
    DeleteCarpoolTripMutationVariables
  >(DELETE_CARPOOL_TRIP);

  const deleteCarpoolTrip = async (tripId: string) => {
    const eventId = currentEventData?.currentEvent?.id;
    if (!eventId) {
      return;
    }

    await mutate({
      variables: { tripId },
      refetchQueries: [
        {
          query: CARPOOL_TRIPS,
          variables: { eventId } satisfies CarpoolTripsQueryVariables,
        },
      ],
    });

    showToast({
      type: 'success',
      message: 'Trajet supprimé.',
    });
  };

  return { deleteCarpoolTrip };
};
